import { fadeColor } from '../utils';

const primarySolid = {
    4: '#F3E4FC',
    5: '#F3E4FC',
    8: '#F3E4FC',
    10: '#dbb0f0',
    12: '#dbb0f0',
    20: '#CD7CF7',
    70: '#a133d9',

    /**
     * @deprecated Prefer mui's `theme.palette.primary.main`.
     */
    100: '#8a00cf',
};

const primaryAlpha = fadeColor(primarySolid[100], 5, 8, 12, 16, 20, 40, 70);

const primaryCustom = {
    dark: '#620093',
};

const blackSolid = {
    3: '#F0EFF0',
    4: '#F0EFF0',
    8: '#D4D2D5',
    20: '#c0bec2',
    70: '#5c5661',
    80: '#4B3560',
    90: '#3D3843',

    /**
     * @deprecated For text color reference mui's `theme.palette.text.primary`.
     */
    100: '#1e0338',
};

const blackCustom = {
    dark: '#160125',
};

const blackCustomDarkAlpha = fadeColor(blackCustom.dark, 80);

const blackAlpha = {
    ...fadeColor(blackSolid[100], 3, 4, 5, 6, 8, 10, 12, 16, 20, 30, 60),

    /**
     * @deprecated For text color reference mui's `theme.palette.text.secondary`.
     */
    70: fadeColor(blackSolid[100], 70)[70],
};

const whiteAlpha = fadeColor('#FFFFFF', 8, 20, 40, 60, 70);

const purpleSolid = {
    4: '#F3E4FC',
    5: '#F3E4FC',
    10: '#dbb0f0',
    12: '#dbb0f0',
    100: '#8a00cf',
};

const purpleAlpha = fadeColor(purpleSolid[100], 5, 8, 10, 12, 16);

const purpleCustom = {
    dark: '#620093',
};

const pinkSolid = {
    4: '#fde9f0',
    12: '#fabcd1',
    100: '#ef2669',
};

const pinkAlpha = fadeColor(pinkSolid[100], 16);

const pinkCustom = {
    dark: '#aa1b4b',
};

const darkblueSolid = {
    4: '#EBE7EF',
    12: '#DBD5E1',
    100: '#1e0338',
};

const darkblueAlpha = fadeColor(darkblueSolid[100], 20);

const darkblueCustom = {
    dark: '#1e0338',
};

const peachCustom = {
    light: '#FF8839',
    dark: '#FF5E82',
};

const goldCustom = {
    light: '#FFD479',
    dark: '#FFAE35',
};

const slateGraySolid = {
    100: '#5c5661',
};

/**
 * @deprecated Use `theme.colors` (semantic tokens) instead.
 */
export const colorsPalette = {
    primarySolid,
    primaryAlpha,
    primaryCustom,
    blackSolid,
    blackAlpha,
    blackCustom,
    blackCustomDarkAlpha,
    whiteAlpha,
    peachCustom,
    purpleSolid,
    purpleAlpha,
    purpleCustom,
    pinkSolid,
    pinkAlpha,
    pinkCustom,
    darkblueSolid,
    darkblueAlpha,
    darkblueCustom,
    goldCustom,
    slateGraySolid,
};
